import React from "react";

const Loader = ({ size = 8, text = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div
        className={`w-12 h-12 border-4 border-t-transparent border-pink-600 rounded-full animate-spin`}
      ></div>
      {text && <p className="mt-4 text-gray-600">{text}</p>}
    </div>
  );
};

export default Loader;
